import React, { useCallback, useEffect, useState } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { WebsocketMessageData } from "../types/websockets";

interface Props {
    setWsMessageHandler: Function
}

export const CommonWebsocket = ({ setWsMessageHandler }: Props) => {
    const [socketUrl, setSocketUrl] = useState(`${process.env.REACT_APP_WEBSOCKET_URL}common/?jwt=${localStorage.getItem('xAuthToken')}`);
    const [messageHistory, setMessageHistory] = useState<MessageEvent<any>[]>([]);

    const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl);

    useEffect(() => {
        if (lastMessage !== null) {
            setMessageHistory((prev) => prev.concat(lastMessage));
            const msg: WebsocketMessageData = JSON.parse(lastMessage.data);
            console.log('wsMessage common: ', msg)
            setWsMessageHandler(msg);
        }
    }, [lastMessage]);

    const handleClickSendMessage = useCallback(() => sendMessage('Hello'), []);

    const connectionStatus = {
        [ReadyState.CONNECTING]: 'Connecting',
        [ReadyState.OPEN]: 'Open',
        [ReadyState.CLOSING]: 'Closing',
        [ReadyState.CLOSED]: 'Closed',
        [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
    }[readyState];

    return <></>;
};